var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"white"},on:{"click":_vm.onClick}},[_c('v-img',{staticClass:"avatar-image",attrs:{"src":_vm.imageUrl,"alt":_vm.name,"lazy-src":_vm.lazySrc},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-skeleton-loader',{attrs:{"type":"image","height":_vm.size}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }